import { isNil } from 'lodash';
import { getMetaFromHTML } from '../meta';
import type { Flags } from './types';

export const getFeatureFlagsFromMetaTag = (metaTagName: string): Flags => {
    const featureFlagsMeta = getMetaFromHTML(metaTagName);
    if (!isNil(featureFlagsMeta) && featureFlagsMeta !== '') {
        try {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return JSON.parse(featureFlagsMeta);
        } catch (e) {
            throw new Error(`Can't parse '${metaTagName}' value`);
        }
    }
    return {};
};
